import { Modal } from "react-bootstrap";
import { AddCommentModalProps } from "./comments.types";
import { Button } from "../button";
import { GenericForm } from "../generic-form";
import { useTranslation } from "react-i18next";

export function AddCommentModal({
  show,
  onCancel,
  onSubmit,
  taskAddCommentForm,
  addingComment,
}: AddCommentModalProps) {
  const { t } = useTranslation();
  return (
    <Modal show={show} animation onHide={onCancel}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("TASKS.ADD_COMMENT_TITLE")}
        </h5>
        <div onClick={onCancel}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={taskAddCommentForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={addingComment}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                {t("TASKS.SEND_COMMENT")}
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
}
